import React from 'react'

import { Image } from '~/components/image/Image'
import { styled } from '~/styled'

import { EmptyStateContext } from './EmptyState.context'

const StyledEmptyStateImage = styled(
  Image,
  {
    base: [],
    variants: {
      size: {
        xs: ['max-h-8', 'max-w-14', 'mb-4'],
        sm: ['max-h-12', 'max-w-21', 'mb-4'],
        md: ['max-h-18', 'max-w-[126px]', 'mb-4'],
        lg: ['max-h-[142px]', 'max-w-[190px]', 'mb-6'],
        xl: ['max-h-[213px]', 'max-w-[285px]', 'mb-6']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type EmptyStateImageProps = React.ComponentProps<typeof StyledEmptyStateImage>

export const EmptyStateImage = (props: EmptyStateImageProps) => {
  const { size } = React.useContext(EmptyStateContext)
  return <StyledEmptyStateImage size={size} {...props} />
}
